import React from "react";
import Admin from "../../components/auth/Admin";
import Layout from "../../components/layout/Layout";
import Company from "../../actions/Company";
import User from "../../actions/User";
import Catagory from "../../actions/Catagory";
import { isAuth } from "../../actions/auth";

const Dashboard = () => {
  const user = isAuth();
  const isAdmin = user && user.roleId === 1;

  const { totalCompany } = Company();
  const { totalSubCatagories, totalMainCatagories } = Catagory();
  const { totalUsers } = User();

  const [companyNum, setCompanyNum] = React.useState(0);
  const [catagoryNum, setCatagoryNum] = React.useState(0);
  const [subCatagoryNum, setSubCatagoryNum] = React.useState(0);
  const [usersNum, setUsersNum] = React.useState(0);

  React.useEffect(() => {
    if (!isAdmin) return;
    totalCompany().then((data) => setCompanyNum(data.result));
    totalUsers().then((data) => setUsersNum(data.result));
    totalSubCatagories().then((data) => setSubCatagoryNum(data.result));
    totalMainCatagories().then((data) => setCatagoryNum(data.result));
  }, []);

  return (
    <Layout>
      <Admin>
        <div className="card">
          {isAdmin && (
            <div class="container">
              <div class="our-team">
                <div class="picture">
                  <i className="bx bx-building-house picture" />
                </div>
                <div class="team-content">
                  <h4 class="name">{companyNum}</h4>
                  <h3 class="title">Companies</h3>
                </div>
              </div>
              <div class="our-team">
                <div class="picture">
                  <i className="bx bx-category picture" />
                </div>
                <div class="team-content">
                  <h4 class="name">{catagoryNum}</h4>
                  <h3 class="title">Catagories</h3>
                </div>
              </div>
              <div class="our-team">
                <div class="picture">
                  <i className="bx bx-category picture" />
                </div>
                <div class="team-content">
                  <h4 class="name">{subCatagoryNum}</h4>
                  <h3 class="title">Sub Catagories</h3>
                </div>
              </div>
              <div class="our-team">
                <div class="picture">
                  <i className="bx bx-user picture" />
                </div>
                <div class="team-content">
                  <h4 class="name">{usersNum}</h4>
                  <h3 class="title">Users</h3>
                </div>
              </div>
            </div>
          )}
        </div>
      </Admin>
    </Layout>
  );
};

export default Dashboard;
